export default {
    state: {
        reports: [],
    },

    mutations: {

        removeReportsByProject(state, projectId) {
            state.reports = state.reports.filter(report => report.project_id !== projectId)
        },

        addReports(state, reports) {
            state.reports = state.reports.concat(reports)
        },

        addReport(state, report) {
            state.reports.push(report)
        },

        updateReport(state, report) {
            const index = state.reports.findIndex(rep => rep.id === report.id)
            if (index < 0) {
                return
            }
            Vue.set(state.reports, index, report)
        },

        syncReport(state, report) {
            const index = state.reports.findIndex(rep => rep.id === report.id)
            if (index >= 0) {
                Vue.set(state.reports, index, report)
            } else {
                state.reports.push(report)
            }
        },

        deleteReport(state, report) {
            const index = state.reports.findIndex(rep => rep.id === report.id)
            if (index < 0) {
                return
            }
            state.reports.splice(index, 1)
        },

        addDay(state, {day, report}) {
            const index = state.reports.findIndex(rep => rep.id === report.id)
            if (index < 0) {
                return
            }
            report.days.push(day)
            Vue.set(state.reports, index, report)
        },

        updateDay(state, {day, report}) {
            const reportIndex = state.reports.findIndex(rep => rep.id === report.id)
            if (reportIndex < 0) {
                return
            }
            const dayIndex = report.days.findIndex(dday => dday.id === day.id)
            if (dayIndex < 0) {
                return
            }
            report[dayIndex] = day
            Vue.set(state.reports, reportIndex, report)
        },

        deleteDay(state, {day, report}) {
            const index = state.reports.findIndex(rep => rep.id === report.id)
            if (index < 0) {
                return
            }
            report.days = report.days.filter(dday => dday.id != day.id)
            Vue.set(state.reports, index, report)
        },

        addReportLine(state, line) {
            const report = state.reports.findIndex(item => item.id === line.report_id)
            state.reports[report].lines.push(line)
        },
        updateReportLine(state, line) {
            const report = state.reports.findIndex(item => item.id === line.report_id)
            const index = state.reports[report].lines.findIndex(item => item.id === line.id)
            Vue.set(state.reports[report].lines, index, line)
        },
        removeReportLine(state, line) {
            const report = state.reports.findIndex(item => item.id === line.report_id)
            state.reports[report].lines = state.reports[report].lines.filter(item => item.id !== line.id)
        },
    },

    getters: {
        reports: state => state.reports,
        reportsByProject: state => projectId => state.reports.filter(report => report.project_id === projectId),
        report: state => reportId => state.reports.find(report => report.id === reportId),
    },

    actions: {

        loadReportsByProject(context, projectId) {
            window.axios.get(`/api/reports/byproject/${projectId}`)
                .then(({data}) => {
                    context.commit('removeReportsByProject', projectId)
                    context.commit('addReports', data)
                })
                .catch(error => console.error(error))
        },

        loadReport(context, reportId) {
            window.axios.get(`/api/reports/${reportId}`)
                .then(({data}) => {
                    context.commit('syncReport', data)
                })
                .catch(error => console.error(error))
        },

        addReport(context, report) {
            context.commit('syncReport', report)
        },

        updateReport(context, report) {
            context.commit('syncReport', report)
        },

        deleteReport(context, report) {
            context.commit('deleteReport', report)
        },

        addDay(context, data) {
            context.commit('addDay', data)
        },

        updateDay(context, data) {
            context.commit('updateDay', data)
        },

        deleteDay(context, data) {
            context.commit('deleteDay', data)
        },

        addReportLine(context, payload) {
            context.commit('addReportLine', payload)
        },
        updateReportLine(context, payload) {
            context.commit('updateReportLine', payload)
        },
        removeReportLine(context, payload) {
            context.commit('removeReportLine', payload)
        },
    }
}
